import Component from '../abstracts/Component';

export default class DropdownComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-profile-login-dropdown',
      icon: '.action'
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();
  }

  desktopBehaviour() {
    let ctx = this;
    this.$on('mouseover.dropdown', ({
      event
    }) => {
      ctx.$emit(ctx.$customEvents.DROPDOWN_EVENTS.open, {
        source: event.currentTarget,
        res: 'lg'
      });
    }, this.SELECTORS.main);

    this.$on('mouseleave.dropdown', ({
      event
    }) => {
      this.$emit(ctx.$customEvents.DROPDOWN_EVENTS.close, {
        source: event.currentTarget,
        res: 'lg'
      });

    }, this.SELECTORS.main);

    $(`${this.SELECTORS.main} ${this.SELECTORS.icon}`).on("keydown", e => {
      const currentDropdown = e.currentTarget.parentElement;
      if (e.which == 13 || e.keyCode == 13) {
        e.preventDefault();
        if (currentDropdown.classList.contains(this.CLASSES.show)) {
          // faccio l'emit del close
          this.$emit(this.$customEvents.DROPDOWN_EVENTS.close, {
            source: currentDropdown,
            res: 'lg'
          });
        } else {
          // faccio l'emit dell'open
          this.$emit(this.$customEvents.DROPDOWN_EVENTS.closeAll);
          ctx.$emit(ctx.$customEvents.DROPDOWN_EVENTS.open, {
            source: currentDropdown,
            res: 'lg'
          });
        }
      }
    });
  }

  bindEvents() {

    if (this.$matchMedia(null, 'lg')) {
      this.desktopBehaviour();
    }

    window.addEventListener('resize', () => {
      if (this.$matchMedia(null, 'lg')) {
        this.desktopBehaviour();
      } else {
        this.$off('mouseover.dropdown', this.SELECTORS.main);
        this.$off('mouseleave.dropdown', this.SELECTORS.main);
      }
    });

  }

  render() {
    this.bindEvents();
  }
}
